import type { ReactNode } from 'react';
import { Skeleton, TypographyMuted } from '@shared/ui';
import { cn } from '@shared/lib/utils';
import { reconciliationTableScrollClass } from '../lib/table-classes';

interface ReconciliationTableShellProps {
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyMessage: string;
  /** Таблица внутри общего surface-card страницы — без второй обводки. */
  embedded?: boolean;
  className?: string;
  children: ReactNode;
}

export function ReconciliationTableShell({
  isLoading = false,
  isEmpty = false,
  emptyMessage,
  embedded = false,
  className,
  children,
}: ReconciliationTableShellProps) {
  const shellClass = embedded ? 'min-w-0' : 'surface-card min-w-0';

  if (isLoading) {
    return (
      <div className={cn(shellClass, 'space-y-3', className)}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-12 w-full rounded-xl" />
        ))}
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className={cn(shellClass, 'py-12 text-center', className)}>
        <TypographyMuted>{emptyMessage}</TypographyMuted>
      </div>
    );
  }

  return (
    <div className={cn(shellClass, className)}>
      <div className={reconciliationTableScrollClass}>{children}</div>
    </div>
  );
}
